import React, {PropsWithChildren, useEffect} from "react";
import styles from "./Drawer.module.scss";

type DrawerProps = {
  open: boolean;
  onClose: () => void;
  className?: string;
};

const Drawer: React.FC<PropsWithChildren<DrawerProps>> = ({children, open, onClose, className = ""}) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add(styles.noScroll);
    } else {
      document.body.classList.remove(styles.noScroll);
    }
  }, [open]);

  return (
    <div
      className={`${styles.wrapper} ${open ? styles.wrapperOpen : ""}`}
      onClick={() => {
        onClose();
      }}
    >
      <div
        onClick={(evt) => {
          evt.stopPropagation();
        }}
        className={`${styles.drawerContainer} ${className} ${open ? styles.open : ""}`}
      >
        <div
          className={`icon icon-close ${styles.closeIcon}`}
          onClick={() => {
            onClose();
          }}
        />
        <div className={styles.childrenWrapper}> {children}</div>
      </div>
    </div>
  );
};

export default Drawer;
